import { cn } from '@/shared/ui/utils/tailwind';
import { Text } from '@/shared/ui';
import { DEAL_STAGE_COLORS, useDealStageLabels, type DealStage } from '../constants/deal-stages';

interface DealStageBadgeProps {
  stage: string;
}

/**
 * Renders a colored badge for the deal's current pipeline stage.
 *
 * @param props.stage - The deal stage string.
 * @returns A badge element with appropriate color and label.
 */
export function DealStageBadge({ stage }: DealStageBadgeProps) {
  const labels = useDealStageLabels();
  const colorClass = DEAL_STAGE_COLORS[stage as DealStage]
    ?? 'bg-[var(--surface-tertiary)] text-[var(--text-secondary)]';
  const label = labels[stage as DealStage] ?? stage;

  return (
    <Text
      component="span"
      className={cn(
        'inline-flex items-center rounded-(--radius-md) px-(--space-2) py-(--space-1)',
        'text-[length:var(--text-meta)] [font-weight:var(--font-semibold)]',
        colorClass,
      )}
    >
      {label}
    </Text>
  );
}
